import {tokens} from '@pleo-io/telescope'
import styled from 'styled-components'

import {container} from '@helios/shared/styles/grid'
import {colors, radii} from '@helios/shared/theme'
import mq from '@helios/shared/utils/media-query'

const mobileStylesBreakpoint = 'xs'

export const Form = styled.form`
    ${container}
    display: grid;
    row-gap: ${tokens.spacing32};
    width: 100%;
    padding: ${tokens.spacing20};
    background: ${colors.background.default};

    ${mq.min(mobileStylesBreakpoint)} {
        max-width: 600px;
        padding: ${tokens.spacing28} ${tokens.spacing40};
        border-radius: ${radii.arc8};
    }
`

export const Titles = styled.div`
    display: grid;
    row-gap: ${tokens.spacing10};
`

export const InputsWrapper = styled.div`
    display: grid;
    gap: ${tokens.spacing20};
    width: 100%;

    ${mq.min(mobileStylesBreakpoint)} {
        row-gap: ${tokens.spacing12};
    }
`

export const Row = styled.div`
    display: grid;
    gap: inherit;
    grid-template-columns: 1fr;

    ${mq.min(mobileStylesBreakpoint)} {
        grid-auto-columns: 1fr;
        grid-auto-flow: column;
    }
`
